module.exports = __webpack_public_path__ + "static/media/29BDOS4.a5c90032.jpg";